var _defs, _g, _g2, _g3, _path, _g4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVenomous(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63.6 84.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #231f20;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.8,83.17c-16.98,0-30.8-13.82-30.8-30.8.69-10.92,6.3-17.85,6.35-17.92L31.8,1.67l24.45,32.81c.08.11,6.31,7.99,6.35,17.9,0,16.98-13.82,30.8-30.8,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m31.8,3.35l23.65,31.73.02.03.02.03c.06.08,6.07,7.71,6.11,17.24,0,16.43-13.37,29.8-29.8,29.8S2.03,68.84,2,52.44c.69-10.56,6.07-17.28,6.13-17.35l.03-.04.03-.04L31.8,3.35m0-3.35L6.58,33.82S.72,40.94,0,52.37c0,17.56,14.24,31.8,31.8,31.8s31.8-14.24,31.8-31.8c-.04-10.4-6.55-18.49-6.55-18.49L31.8,0h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m49.57,59.76l-3.94,6.66c-2.37-4.28-7.75-8.04-15.3-12.7-9.66-6.86-13.62-8.32-16.47-9.03l4.82-7.02c.7,1.96,2.35,4.58,14.14,12.69,9.57,6.63,15.33,9.81,16.75,9.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 13.48,
    cy: 42.77,
    rx: 4.14,
    ry: 4.3,
    transform: "translate(-29.18 28.94) rotate(-54.54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16.56,
    cy: 38.57,
    rx: 3.99,
    ry: 4.37,
    transform: "translate(-24.46 29.68) rotate(-54.54)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 48.07,
    cy: 66.37,
    rx: 3.96,
    ry: 4.51,
    transform: "translate(-33.87 67.58) rotate(-54.93)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 50.69,
    cy: 61.79,
    rx: 3.88,
    ry: 4.31,
    transform: "translate(-29.01 67.78) rotate(-54.93)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19,66.14l-4.93-5.96c4.83-.78,10.19-4.56,17.14-10.08,9.73-6.76,12.44-9.99,14.08-12.43l4.97,6.92c-2.09,0-5.11.66-16.73,9-9.48,6.76-14.42,11.09-14.53,12.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 47.22,
    cy: 37.95,
    rx: 4.3,
    ry: 4.14,
    transform: "translate(-13.21 33.64) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 50.13,
    cy: 42.27,
    rx: 4.37,
    ry: 3.99,
    transform: "translate(-15.15 36.07) rotate(-34.71)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 13.29,
    cy: 62.49,
    rx: 4.51,
    ry: 3.96,
    transform: "translate(-33.52 19.01) rotate(-35.11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 16.71,
    cy: 66.5,
    rx: 4.31,
    ry: 3.88,
    transform: "translate(-35.21 21.71) rotate(-35.11)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.81,51.5c0-7.43-6.02-13.45-13.45-13.45s-13.45,6.02-13.45,13.45c.1,5.87,4.78,6.8,6.02,11.27v4.06c0,.74.6,1.34,1.34,1.34h12.38c.74,0,1.34-.6,1.34-1.34v-4.49c1.35-3.73,6.13-4.56,5.82-10.84Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.06,48.02c-1.81,0-3.27,1.07-3.27,2.39s1.46,2.39,3.27,2.39,3.27-1.07,3.27-2.39-1.46-2.39-3.27-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m36.86,48.02c-1.81,0-3.27,1.07-3.27,2.39s1.46,2.39,3.27,2.39,3.27-1.07,3.27-2.39-1.46-2.39-3.27-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.62,54.56c-1.32,0-2.39,1.46-2.39,3.27s1.07,1.46,2.39,1.46,2.39.35,2.39-1.46-1.07-3.27-2.39-3.27Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.53,
    y: 64.61,
    width: 2.18,
    height: 3.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 30.68,
    y: 64.61,
    width: 2.18,
    height: 3.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 34.73,
    y: 64.61,
    width: 2.18,
    height: 3.56
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenomous);
export default __webpack_public_path__ + "static/media/Venomous.bcb947ce86d58d56e2fb29ed2b9e0941.svg";
export { ForwardRef as ReactComponent };